import React from 'react';
import PropTypes from 'prop-types';
import { TransactionCard, RowC, ColC, LayoutC } from 'fpay-ui';

const OperationTableSmall = ({ dataBody, properity = [] }) => (
  <LayoutC>
    {dataBody &&
      dataBody?.map((el, i) => (
        <>
          <TransactionCard key={i}>
            <ColC key={i}>
              <RowC type="title">{el.op}</RowC>
              <RowC>{el.card}</RowC>
              <RowC>{el.data}</RowC>
            </ColC>
            <ColC>
              <RowC type="title" justify="flex-end">
                {el.amount}
              </RowC>
              <RowC justify="flex-end">{el.qr}</RowC>
              <RowC justify="flex-end">{el.hour}</RowC>
            </ColC>
          </TransactionCard>
        </>
      ))}
  </LayoutC>
);

export default OperationTableSmall;

OperationTableSmall.propTypes = {
  dataHeader: PropTypes.array,
  dataBody: PropTypes.array,
  properity: PropTypes.array,
};

OperationTableSmall.defaultProps = {
  dataHeader: undefined,
  dataBody: undefined,
  properity: undefined,
};
